import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from 'app/redux/store';

import { DownloadsItemState, DownloadsState } from '../types';

const initialState: DownloadsState = {
  downloads: [],
  downloading: false,
  downloadingPercentage: 0,
};

const downloadsSlice = createSlice({
  name: 'downloads',
  initialState,
  reducers: {
    setDownloadsAction(state, action: PayloadAction<DownloadsItemState[]>) {
      state.downloads = action.payload;
    },

    clearDownloadsAction(state) {
      state.downloads = [];
    },

    setDownloadingAction(state, action: PayloadAction<boolean>) {
      state.downloading = action.payload;
    },

    setDownloadingPercentageAction(state, action: PayloadAction<number>) {
      state.downloadingPercentage = action.payload;
    },
  },
});

export const { setDownloadsAction, clearDownloadsAction, setDownloadingAction, setDownloadingPercentageAction } = downloadsSlice.actions;

export const getDownloads = (state: RootState): DownloadsState => state.downloads;

export default downloadsSlice.reducer;
